// @packages
import axios, {
  AxiosRequestConfig, AxiosRequestHeaders, Method
} from 'axios';
import { getUserState } from '../core/context/provider';

import { format } from '../utils/string';

type ParamEncodable = string[] | number[]
export type RouteDescriptor = string | [string, ...ParamEncodable];

class BaseService {
  protected readonly routes: Record<string, string>;

  constructor(routes:Record<string, string>) {
    this.routes = routes;
  }

  protected headers(token:string|undefined): AxiosRequestHeaders {
    return {
      Authorization: token ? `Bearer ${token}` : 'None',
      'Content-Type': 'application/json'
    };
  }

  protected async request<T>(
    method: Method | string,
    route: RouteDescriptor,
    config?: AxiosRequestConfig
  ): Promise<T> {
    const user = await getUserState();
    const res = await axios.request<T>({
      ...config,
      method,
      headers: { ...config?.headers, ...this.headers(user?.jwtToken) },
      url: Array.isArray(route)
        ? format(this.routes[route[0]], ...route.slice(1) as ParamEncodable)
        : this.routes[route]
    });
    return res.data;
  }

  protected async get<T>(
    route: RouteDescriptor,
    config?:AxiosRequestConfig
  ): Promise<T> {
    return this.request<T>('GET', route, config);
  }

  protected async put<T>(
    route: RouteDescriptor,
    config?:AxiosRequestConfig
  ): Promise<T> {
    return this.request<T>('PUT', route, config);
  }
}

export default BaseService;
